import { useState } from "react";

/**
 * @typedef UseColumnSelectionProps 
 * @prop {string[]} columns
 * @prop {string} [sortDir]
 * @prop {string} [sortBy]
 * @prop {string} [defaultSortDir]
 */

/**
 * @param {UseColumnSelectionProps} props
 */
const useColumnSelection = (props) => {
  const [sortBy, setSortBy] = useState(props.sortBy || "");
  const [sortDir, setSortDirection] = useState(props.sortDir || "asc");

  const onSelectColumn = (col) => {
    if (!props.columns.includes(col)) throw new Error(`invalid column selection: ${col} `);

    if (col !== sortBy) {
      setSortDirection(props.defaultSortDir || "asc");
    } else {
      setSortDirection(sortDir === "asc" ? "desc" : "asc");
    }

    setSortBy(col);
  };

  return {
    onSelectColumn,
    sortDir,
    sortBy,
  };
};

export default useColumnSelection;
